<template>
  <v-card class="box-container" style="max-height: 500px">
    <v-card-title class="row-header ma-0 pa-0">
      <v-row class="ma-0 pa-0" justify="center" align="center">
        <!-- <v-btn color="none" text fab small class="no-background-hover" :ripple="false" style="cursor: default">
          <v-divider></v-divider>
        </v-btn>-->
        <v-divider></v-divider>
        <span class="ma-2 subtitle-1">{{ s_Filters }}</span>
        <v-divider></v-divider>
        <!-- <v-btn color="error" text fab small @click="closeThis()">
          <v-icon>mdi-close</v-icon>
        </v-btn>-->
      </v-row>
    </v-card-title>
    <div class="ma-0 pa-0 row-content">
      <v-row v-for="(filter, fIdx) in getFilters()" :key="fIdx" class="ma-0 pa-0" align="center" justify="center">
        <v-col cols="12" v-if="isOnMobile" class="px-2 py-0 ma-0">
          <v-btn class="ma-0 pa-0" tile x-small color="red" icon @click="removeFilter($event, fIdx)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <span class="caption">{{ filter.toString() }}</span>
        </v-col>
        <v-row class="pa-2 ma-0" v-if="isOnMobile ? filter.isActive : true">
          <v-col sm="12" md="4" lg="4" cols="12" class="ma-0 pa-1">
            <v-row class="ma-0 pa-0" justify="space-between">
              <v-btn v-if="!isOnMobile" :color="Colors.IconColor" icon class="align-self-center" small @click="removeFilter($event, fIdx)">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
              <label :ref="'refPropName' + fIdx" :style="isOnMobile ? 'width: 100%;' : 'width: calc(100% - 32px);'">
                <v-select :items="dataheaders" :no-data-text="s_NoData" v-model="filter.propname" @change="setFilterText(fIdx, filter.propname)" :label="sType" dense hide-details></v-select>
              </label>
            </v-row>
          </v-col>
          <v-col sm="12" md="4" lg="4" cols="12" class="ma-0 pa-1">
            <label :ref="'refFilterType' + fIdx">
              <v-select :items="getFiltersByPropType(datafilters[fIdx].proptype)" :no-data-text="s_NoData" v-model="filter.type" return-object @change="filterTypeChanged(fIdx, filter)" :label="s_Action" class="centered-input" dense hide-details></v-select>
            </label>
          </v-col>
          <v-col sm="12" md="4" lg="4" cols="12" class="ma-0 pa-1">
            <v-row class="ma-0 pa-0">
              <label class="ma-0 pa-0" v-if="filter.type == DataFilterType.In" :ref="'refPropValue' + fIdx">
                <v-select v-if="filter.type == DataFilterType.In" v-model="filter.vals" :items="getFilterDistinctValues(datatype, filter)" :label="s_Values" multiple dense hide-details style="z-index: 9999"></v-select>
              </label>
              <v-switch class="ma-0 pa-1" v-else-if="filter.proptype == DataPropType.BOOL" v-model="filter.vals[0]" :label="filter.vals[0] ? s_Yes : s_No" dense inset />
              <v-text-field class="ma-0 pa-1" style="width: 50%; min-width: 80px" v-else-if="filter.proptype != DataPropType.Date" :label="filter.type == DataFilterType.Between ? s_From : s_Value" v-model="filter.vals[0]" dense hide-details></v-text-field>
              <v-text-field class="ma-0 pa-1" style="width: 50%; min-width: 80px" v-if="filter.proptype != DataPropType.Date && filter.type == DataFilterType.Between" :label="s_To" v-model="filter.vals[1]" dense></v-text-field>

              <t-date-range-input class="ma-0 pa-1" v-if="filter.type == DataFilterType.Between && filter.proptype == DataPropType.Date" v-model="filter.vals" :label="filter.text"></t-date-range-input>
              <v-dialog v-if="filter.type != DataFilterType.Between && filter.proptype == DataPropType.Date" ref="refCalendarSingle" v-model="modalCalendar_single" width="290px">
                <template v-slot:activator="{ on }">
                  <label class="ma-0 pa-1" :ref="'refPropValue' + fIdx">
                    <v-text-field v-on="on" class="ma-0 pa-0" maxlength="10" :value="new Date(date).toTremolFpStringShort()" dense hide-details></v-text-field>
                  </label>
                </template>
                <v-date-picker firstDayOfWeek="1" type="date" locale="bg" v-model="date">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modalCalendar_single = false">{{ s_Cancel }}</v-btn>
                  <v-btn text color="primary" @click="setDate(filter)">{{ s_OK }}</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-row>
          </v-col>
        </v-row>
      </v-row>
    </div>

    <v-row class="row-header" :class="isOnMobile ? 'px-1 py-2 ma-0' : 'px-3 py-2 ma-0'" :justify="isOnMobile ? 'center' : 'start'" align="center">
      <t-button :class="'ma-1'" :btnText="s_Add" :btnIcon="'mdi-filter'" @click="addFilter" />
      <v-spacer v-if="!isOnMobile"></v-spacer>
      <t-button :class="'ma-1'" :btnText="s_Cancel" :btnIcon="'mdi-close'" @click="closeThis()" />
      <t-button :class="'ma-1'" :btnText="s_OK" :btnIcon="'mdi-check-bold'" @click="setFilters()" />
    </v-row>
  </v-card>
</template>

<script>
import { DataFilter, DataFilterType, DataPropType } from "@/data/DataFilter.js";
import DataManager from "@/data/DataManager.js";

export default {
  name: "myFilter",
  data() {
    return {
      modalCalendar_range: false,
      modalCalendar_single: false,
      date: new Date().toStringWithFormat("yyyy-MM-dd"),
      dates: [new Date().toStringWithFormat("yyyy-MM-dd"), new Date().toStringWithFormat("yyyy-MM-dd")],
      filterTypes: [],
      /** @type {DataFilter[]} */
      datafilters: [],
      /** @type {DataHeader[]} */
      dataheaders: [],
      dataitems: [],
      datatype: null,
      filtersText: [],
      s_Filters: "Филтри",
      s_NoData: "Няма данни",
      sType: "Тип",
      s_Action: "Действие",
      s_Yes: "Да",
      s_No: "Не",
      s_From: "От",
      s_To: "До",
      s_Value: "Стойност",
      s_Values: "Стойности",
      s_OK: "ОК",
      s_Cancel: "Отказ",
      s_Add: "Добави",
    };
  },
  methods: {
    setFilters() {
      DataManager.setFilters(this.datatype, this.datafilters);
      if (this.datafilters.some((f) => !f.propname || !f.proptype || !f.vals[0])) {
        this.dialog.showError("Не са избрани филтри", { location: "center" });
        return;
      }
      this.datafilters.forEach((filter) => {
        this.filtersText.push(filter.toString());
      });
      this.closeThis();
    },
    getFilterDistinctValues(datatype, datafilter) {
      return DataManager.getFilterDistinctValues(datatype, datafilter);
    },
    getFilters() {
      if (this.isOnMobile && this.datafilters.length > 0) {
        this.datafilters.forEach((filter) => {
          if (filter.isActive) filter.isActive = false;
        });
        this.datafilters[this.datafilters.length - 1].isActive = true;
      }
      return this.datafilters;
    },
    getFiltersByPropType(proptype) {
      return DataManager.getFilterTypesByPropType(proptype);
    },
    addFilter(e, fIdx) {
      if (!fIdx) {
        fIdx = this.datafilters.length;
      }
      this.datafilters.splice(fIdx, 0, new DataFilter());
      this.$nextTick(() => {
        this.$refs["refPropName" + (this.datafilters.length - 1)][0].click();
      });
    },
    setFilterText(idx, propName) {
      var found = this.dataheaders.find((f) => f.value == propName);
      this.datafilters[idx].text = found.text;
      this.datafilters[idx].vals = [];
      this.datafilters[idx].proptype = found.proptype;
      this.$refs["refFilterType" + idx][0].click();
    },
    filterTypeChanged(idx, filter) {
      filter.vals = [];
      this.$nextTick(() => {
        if (this.$refs["refPropValue" + idx] && this.$refs["refPropValue" + idx].length > 0) {
          this.$refs["refPropValue" + idx][0].click();
        }
      });
    },
    removeFilter(e, fIdx) {
      // if (!fIdx) {
      //   fIdx = this.datafilters.length - 1;
      // }
      //if (this.datafilters.length > 0) {
      this.datafilters.splice(fIdx, 1);
      //}
    },
    keyUp(e, filter) {
      filter.vals = e.target.value.split("\n");
      e.target.rows = filter.vals.length;
    },
    setDate(filter) {
      this.$refs.refCalendarSingle[0].save(this.date);
      filter.vals[0] = new Date(this.date).getDateWithoutTime();
    },
    // setDates(filter) {
    //   this.$refs.refCalendarRange[0].save(this.dates);
    //   if (!this.dates[0]) this.dates[0] = this.dates[1];
    //   if (!this.dates[1]) this.dates[1] = this.dates[0];
    //   filter.vals[0] = new Date(this.dates[0]).getDateWithoutTime();
    //   filter.vals[1] = new Date(this.dates[1]).getDateWithoutTime();
    //   if (filter.vals[0] > filter.vals[1]) {
    //     filter.vals.reverse();
    //     this.dates.reverse();
    //   }
    //   filter.vals[1] = filter.vals[1].addDays(1);
    // },
    getInputType(filter) {
      if (filter.proptype == DataPropType.Date) return "date";
      else if (filter.proptype == DataPropType.Number) return "number";
      else return "text";
    },
    closeThis() {
      this.dialog.close();
    },
  },
  computed: {
    DataPropType() {
      return DataPropType;
    },
    DataFilterType() {
      return DataFilterType;
    },
  },
  created() {
    this.datatype = this.dialog.data;
    this.dataheaders = DataManager.getHeaders(this.datatype).map((i) => ({
      text: i.text,
      value: i.value,
      proptype: i.proptype,
      sort: i.sort,
    }));
    this.datafilters = DataManager.getFilters(this.datatype.id).map((i) => {
      var o = Object.assign({}, i);
      o.toString = i.toString;
      return o;
    });
    this.dataitems = DataManager.getData(this.datatype).map((i) => i);
  },
};
</script>
<style>
</style>